import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../Button';
import { useParallax } from '../../hooks/useParallax';
export function Hero() {
  const {
    ref,
    y
  } = useParallax(150);
  return <section ref={ref} className="relative min-h-[90vh] flex items-center justify-center overflow-hidden pt-20" data-id="element-92">
      {/* Illustrated SVG sky background with parallax clouds & sparkles */}
      <motion.div style={{
      y
    }} className="absolute inset-0 z-0 w-full h-[120%] -top-[10%]" aria-hidden="true" data-id="element-93">
        <svg className="w-full h-full" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice" data-id="element-94">
          <defs data-id="element-95">
            <linearGradient id="heroSky" x1="0" y1="0" x2="0" y2="1" data-id="element-96">
              <stop offset="0%" stopColor="#C9DCF5" data-id="element-97" />
              <stop offset="100%" stopColor="#FAF7F0" data-id="element-98" />
            </linearGradient>
            <filter id="cloudBlur" x="-20%" y="-20%" width="140%" height="140%" data-id="element-99">
              <feGaussianBlur stdDeviation="14" data-id="element-100" />
            </filter>
            <radialGradient id="cloudFill" cx="50%" cy="50%" r="50%" data-id="element-101">
              <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.95" data-id="element-102" />
              <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0.55" data-id="element-103" />
            </radialGradient>
          </defs>

          {/* Sky */}
          <rect width="1440" height="900" fill="url(#heroSky)" data-id="element-104" />

          {/* Soft wispy clouds */}
          <g filter="url(#cloudBlur)" opacity="0.7" data-id="element-105">
            <ellipse cx="180" cy="160" rx="240" ry="80" fill="url(#cloudFill)" data-id="element-106" />
            <ellipse cx="320" cy="200" rx="160" ry="60" fill="url(#cloudFill)" data-id="element-107" />
            <ellipse cx="1280" cy="120" rx="280" ry="90" fill="url(#cloudFill)" data-id="element-108" />
            <ellipse cx="1120" cy="170" rx="170" ry="60" fill="url(#cloudFill)" data-id="element-109" />
            <ellipse cx="720" cy="60" rx="220" ry="70" fill="url(#cloudFill)" data-id="element-110" />
            <ellipse cx="540" cy="640" rx="260" ry="80" fill="url(#cloudFill)" data-id="element-111" />
            <ellipse cx="1180" cy="600" rx="240" ry="78" fill="url(#cloudFill)" data-id="element-112" />
          </g>

          {/* Gold sparkles - mix of 4-point stars and cross sparkles */}
          <g fill="#D4AF6A" data-id="element-113">
            {/* 4-point stars */}
            <path d="M250 340 C252 358 258 364 276 366 C258 368 252 374 250 392 C248 374 242 368 224 366 C242 364 248 358 250 340 Z" opacity="0.9" data-id="element-114" />
            <path d="M1130 420 C1131.4 432.6 1135.4 436.6 1148 438 C1135.4 439.4 1131.4 443.4 1130 456 C1128.6 443.4 1124.6 439.4 1112 438 C1124.6 436.6 1128.6 432.6 1130 420 Z" opacity="0.85" data-id="element-115" />
            <path d="M340 210 C341.6 224.4 346.6 229.4 361 231 C346.6 232.6 341.6 237.6 340 252 C338.4 237.6 333.4 232.6 319 231 C333.4 229.4 338.4 224.4 340 210 Z" opacity="0.7" data-id="element-116" />
            <path d="M360 640 C361.2 650.8 365.2 654.8 376 656 C365.2 657.2 361.2 661.2 360 672 C358.8 661.2 354.8 657.2 344 656 C354.8 654.8 358.8 650.8 360 640 Z" opacity="0.6" data-id="element-117" />
            <path d="M980 700 C981.8 716.2 987.8 722.2 1004 724 C987.8 725.8 981.8 731.8 980 748 C978.2 731.8 972.2 725.8 956 724 C972.2 722.2 978.2 716.2 980 700 Z" opacity="0.85" data-id="element-118" />
            <path d="M420 520 C421.2 530.8 425.2 534.8 436 536 C425.2 537.2 421.2 541.2 420 552 C418.8 541.2 414.8 537.2 404 536 C414.8 534.8 418.8 530.8 420 520 Z" opacity="0.8" data-id="element-119" />

            {/* Cross sparkles (simple plus-shaped twinkles) */}
            <g opacity="0.6" data-id="element-120">
              <rect x="1060" y="200" width="4" height="28" rx="2" data-id="element-121" />
              <rect x="1048" y="212" width="28" height="4" rx="2" data-id="element-122" />
            </g>
            <g opacity="0.8" data-id="element-123">
              <rect x="312" y="430" width="3" height="20" rx="1.5" data-id="element-124" />
              <rect x="303.5" y="438.5" width="20" height="3" rx="1.5" data-id="element-125" />
            </g>
            <g opacity="0.8" data-id="element-126">
              <rect x="1228" y="300" width="3" height="22" rx="1.5" data-id="element-127" />
              <rect x="1218.5" y="309.5" width="22" height="3" rx="1.5" data-id="element-128" />
            </g>
            <g opacity="0.6" data-id="element-129">
              <rect x="1060" y="680" width="3" height="18" rx="1.5" data-id="element-130" />
              <rect x="1052.5" y="688" width="18" height="3" rx="1.5" data-id="element-131" />
            </g>
            <g opacity="0.8" data-id="element-132">
              <rect x="1080" y="250" width="2.5" height="16" rx="1.25" data-id="element-133" />
              <rect x="1073.25" y="257.75" width="16" height="2.5" rx="1.25" data-id="element-134" />
            </g>
          </g>
        </svg>
      </motion.div>

      {/* Mobile-only sparkles — positioned in the corners relative to the hero box, clear of the centered text */}
      <div className="absolute inset-0 z-[1] pointer-events-none sm:hidden" aria-hidden="true" data-id="element-135">
        <svg className="absolute left-[10%] top-[15%] w-5 h-5 text-brand-gold opacity-70" viewBox="0 0 24 24" fill="currentColor" data-id="element-136">
          <path d="M12 1 C12.8 8 13.8 9 21 12 C13.8 15 12.8 16 12 23 C11.2 16 10.2 15 3 12 C10.2 9 11.2 8 12 1 Z" data-id="element-137" />
        </svg>
        <svg className="absolute right-[12%] top-[12%] w-4 h-4 text-brand-gold opacity-60" viewBox="0 0 24 24" fill="currentColor" data-id="element-138">
          <rect x="11" y="2" width="2" height="20" rx="1" data-id="element-139" />
          <rect x="2" y="11" width="20" height="2" rx="1" data-id="element-140" />
        </svg>
        <svg className="absolute left-[13%] bottom-[18%] w-4 h-4 text-brand-gold opacity-60" viewBox="0 0 24 24" fill="currentColor" data-id="element-141">
          <rect x="11" y="2" width="2" height="20" rx="1" data-id="element-142" />
          <rect x="2" y="11" width="20" height="2" rx="1" data-id="element-143" />
        </svg>
        <svg className="absolute right-[11%] bottom-[15%] w-5 h-5 text-brand-gold opacity-70" viewBox="0 0 24 24" fill="currentColor" data-id="element-144">
          <path d="M12 1 C12.8 8 13.8 9 21 12 C13.8 15 12.8 16 12 23 C11.2 16 10.2 15 3 12 C10.2 9 11.2 8 12 1 Z" data-id="element-145" />
        </svg>
      </div>

      {/* Soft radial glow behind the headline — contained so it doesn't wash out the sparkles */}
      <div className="absolute inset-0 z-[1] flex items-center justify-center pointer-events-none" data-id="element-146">
        <div className="w-[90vw] max-w-[640px] h-[300px] sm:h-[520px] rounded-[50%] bg-white/45 blur-2xl" data-id="element-147" />
      </div>

      <div className="container mx-auto px-4 relative z-10 text-center max-w-4xl mt-20" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-149">
          <p className="text-brand-gold font-bold tracking-[0.2em] uppercase text-sm mb-6" data-id="element-150">
            ✦ Residential & Commercial Cleaning ✦
          </p>

          <h1 className="font-serif text-4xl md:text-6xl lg:text-[72px] leading-tight text-brand-charcoal mb-6" data-id="element-151">
            Your Home, <br className="md:hidden" data-id="element-152" />
            <span className="relative inline-block" data-id="element-153">
              Spotlessly Blessed.
              <svg className="absolute w-full h-3 -bottom-1 left-0 text-brand-gold/30" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-154">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="none" data-id="element-155" />
              </svg>
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-brand-charcoal/70 mb-10 max-w-2xl mx-auto font-light" data-id="element-156">
            We clean like it's sacred, because your home is.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16" data-id="element-157">
            <Button className="w-full sm:w-auto bg-brand-gold hover:bg-brand-gold/90 text-white rounded-full px-8 min-h-[52px] text-lg shadow-soft-lg transition-transform hover:-translate-y-1" data-id="element-158">
              Book a Free Estimate
            </Button>
            <Button variant="outline" className="w-full sm:w-auto border-brand-blue text-brand-blue hover:bg-brand-blue/5 rounded-full px-8 min-h-[52px] text-lg bg-transparent" data-id="element-159">
              See Our Services
            </Button>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm font-medium text-brand-charcoal/80" data-id="element-160">
            <span className="flex items-center gap-2" data-id="element-161">
              <span className="text-brand-gold" data-id="element-162">✦</span> Bonded & Insured
            </span>
            <span className="hidden md:inline text-brand-blue/30" data-id="element-163">|</span>
            <span className="flex items-center gap-2" data-id="element-164">
              <span className="text-brand-gold" data-id="element-165">✦</span> Satisfaction Guaranteed
            </span>
            <span className="hidden md:inline text-brand-blue/30" data-id="element-166">|</span>
            <span className="flex items-center gap-2" data-id="element-167">
              <span className="text-brand-gold" data-id="element-168">✦</span> 5-Star Rated
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}